import React, { useEffect, useState } from "react";
import { motion, animate, useMotionValue } from "framer-motion";
import useMeasure from "react-use-measure";
import Card from "./Card";

const Testimonials = () => {
  const FAST_DURATION = 25; // Fast animation duration
  const SLOW_DURATION = 75; // Slow animation duration

  // Static data for clients
  const staticClients = [
    {
      name: "Dey's Publishing",
      image: "/app_icon.png",
      testimonial:
        "Working with this team has transformed our online presence. Their creativity and professionalism exceeded our expectations!",
    },
    {
      name: "Newtown Sarbajanin",
      image: "/sarbojanin.png",
      testimonial:
        "The website was exactly what we needed! A seamless experience from start to finish. Highly recommended!",
    },
    {
      name: "AI Champ",
      image: "/AIchamp_logo.png",
      testimonial:
        "An absolute pleasure to work with. They understood our vision and delivered a website that truly stands out.",
    },
    {
      name: "Sand Dune",
      image: "/sand_dune.png",
      testimonial:
        "Impressed with their dedication and technical expertise. The result was better than we could have imagined.",
    },
    // Add more clients as needed
  ];

  const [clients, setClients] = useState(staticClients); // Use static data
  const [loaded, setLoaded] = useState(true); // Mark data as loaded
  const [duration, setDuration] = useState(FAST_DURATION);
  const [mustFinish, setMustFinish] = useState(false);
  const [rerender, setRerender] = useState(false);
  let [ref, { width }] = useMeasure();

  const xTranslation = useMotionValue(0);

  // Scrolling animation
  useEffect(() => {
    let controls;
    const finalPosition = -width / 2 - 19;

    if (mustFinish) {
      controls = animate(xTranslation, [xTranslation.get(), finalPosition], {
        ease: "linear",
        duration: duration * (1 - xTranslation.get() / finalPosition),
        onComplete: () => {
          setMustFinish(false);
          setRerender(!rerender);
        },
      });
    } else {
      controls = animate(xTranslation, [0, finalPosition], {
        ease: "linear",
        duration: duration,
        repeat: Infinity,
        repeatType: "loop",
        repeatDelay: 0,
      });
    }

    return controls?.stop;
  }, [rerender, xTranslation, duration, width]);

  return (
    <div className="relative py-[10vh] h-[70vh] md:h-[50vh] lg:h-[60vh] xl:h-[70vh] overflow-x-hidden flex justify-center items-center bg-[#201f1f]">
      {/* Title */}
      <div className="absolute top-0 flex justify-center items-center ">
        <h1 className="text-[#F3F4F5] font-bold text-2xl md:text-3xl lg:text-4xl mt-[8vh] z-30 relative">
          Clients <span className="italic text-[#ae0c00]">& </span>
          <span className="italic font-thin">Testimonials</span>
        </h1>
      </div>

      {/* Carousel */}
      <motion.div
        className="absolute top-[25vh] md:top-[20vh] lg:top-[25vh] left-0 flex gap-6 md:gap-8 lg:gap-10"
        style={{ x: xTranslation }}
        ref={ref}
        onHoverStart={() => {
          setMustFinish(true);
          setDuration(SLOW_DURATION);
        }}
        onHoverEnd={() => {
          setMustFinish(true);
          setDuration(FAST_DURATION);
        }}
      >
        {[...clients, ...clients].map((item, idx) => (
          <motion.div
            key={idx}
            initial={{ opacity: loaded ? 0 : 1 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1 }} // Adjust duration for fade-in
          >
            <Card
              image={`${item.image}`}
              name={item.name}
              testimonial={item.testimonial}
            />
          </motion.div>
        ))}
      </motion.div>

      {/* Overlay gradient */}
      <div className="absolute inset-0 z-10 h-[70vh] md:h-[50vh] lg:h-[60vh] xl:h-[70vh] w-screen pointer-events-none bg-gradient-to-r from-[#111010] via-transparent to-[#111010]" />
    </div>
  );
};

export default Testimonials;
